<template src='./confirmModal.pug' lang='pug'></template>

<script>
export default {
  name: 'ConfirmDialog',

  props: [
    'id'
  ],

  methods: {
    closeModal () {
      $('#' + this.id).modal('hide')
    }
  }
}
</script>

<style scoped>
.confirm {
  z-index: 10000 !important;
  backdrop-filter: brightness(0.5);
}

.confirm-modal-header {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  background-color: #1b3c65;
  color: #fff;
  padding: 0.5vh 0vh 0.5vh 1vh;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.confirm-modal-header h1 {
  font-size: 3vh;
  margin-top: 10px;
  margin-bottom: 0px;
}

.confirm-content {
  border-radius: 0px !important;
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}
.confirm-text {
  font-size: 2vh;
  text-align: left;
  color: #1a3b5f;
}

.confirm-dialog {
  width: 28vw !important;
}

.confirm-buttom {
  font-size: 1.7vh !important;
  min-width: 80px !important;
}
.confirm-footer {
  padding: 0px 20px 0px 20px !important;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// ConfirmModal.vue?62b2d54a